import EarningsBarChart from "../components/EarningsBarChart";
import WorkerPieChart from "../components/WorkerPieChart";
const Home = () => {
    return (
        <div className="flex flex-col w-full max-w-md mx-auto px-3 pt-4 pb-24">
            <EarningsBarChart />
            <WorkerPieChart />
        </div>
    );
};

export default Home;